export default function ChartTooltip({ active, payload, label, valueFormatter, showTotal }) {
  if (!active || !payload?.length) return null;
  const total = showTotal
    ? payload.reduce((sum, entry) => sum + Number(entry.value || 0), 0)
    : null;
  return (
    <div className="rounded-xl border border-theme-secondary bg-theme-main px-3 py-2 text-xs shadow-lg">
      <div className="font-medium mb-1.5 opacity-80">{label}</div>
      {payload.map((entry) => (
        <div key={entry.dataKey} className="flex items-center gap-2 py-0.5">
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background: entry.color }} />
          <span className="opacity-70">{entry.name}:</span>
          <span className="font-medium ml-auto">{valueFormatter(entry.value)}</span>
        </div>
      ))}
      {showTotal && (
        <div className="flex items-center gap-2 pt-1.5 mt-1 border-t border-theme-secondary">
          <span className="opacity-70">Total:</span>
          <span className="font-medium ml-auto">{valueFormatter(total)}</span>
        </div>
      )}
    </div>
  );
}
